import { render, staticRenderFns } from "./IusaLogo.vue?vue&type=template&id=08d3ea12&"
import script from "./IusaLogo.vue?vue&type=script&lang=js&"
export * from "./IusaLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports